import(/* webpackMode: "eager" */ "/app/apps/admin/src/app/not-found.tsx");
